import React, { useEffect, useState } from "react";
import "./Landing_page.css";

import usdt from "../Assets/usdt.svg";
import usd from "../Assets/usdc.png";

import { useAccount, useContractWrite, useNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useSwitchNetwork } from "wagmi";
import { toast } from "react-hot-toast";
import { useBalance } from "wagmi";
import Web3 from "web3";
import CopyToClipboard from "react-copy-to-clipboard";

import { useMediaQuery } from "react-responsive";

import bnb from "../Assets/bnb.svg";
import usdt2 from "../Assets/usdt.svg";
import fndr from "../Assets/pikachuLogo-removebg-preview.png";



import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";

import {
  PikuPresaleABI,
  PikuPresale,
  TetherToken_Abi,
  TetherToken_Address,
  USD_Coin_Address,
  USD_Coin_Abi,
} from "../../util/Contract";

import Countdown from "react-countdown";
const Completionist = () => {
  // window.location.reload();
  return <></>;
};






const renderer = ({ days, hours, minutes, seconds, completed }) => {
  // console.log("renderer",items);
  if (completed) {
    return <Completionist />;
  } else {
    return (
      <div className="row timer_here">
        <div className="col-3">
          <div>
            <h1 className="numbers">{days}</h1>
            <p className="days site_font mb-0">DAYS</p>
          </div>
        </div>
        <div className="col-3">
          <div>
            <h1 className="numbers">{hours}</h1>
            <p className="days site_font mb-0">HOURS</p>
          </div>
        </div>
        <div className="col-3">
          <div>
            <h1 className="numbers">{minutes}</h1>
            <p className="days site_font mb-0">Minutes</p>
          </div>
        </div>
        <div className="col-3">
          <div>
            <h1 className="numbers">{seconds}</h1>
            <p className="days site_font mb-0">Seconds</p>
          </div>
        </div>
      </div>
    );
  }
};

export default function Landing_page() {
  const [show, setShow] = useState(false);

  const [refAddress, setRefAddress] = useState("");
  const [copied, setCopied] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  const isPC = useMediaQuery({ minWidth: 768 });

  const [raiseUsdt, setRaiseUSDT] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address, isConnecting, isDisconnected } = useAccount();
  const { open, close } = useWeb3Modal();
  const [isActive, setisActive] = useState(0);
  const [Token_Balance, setToken_Balance] = useState(0);
  const [get_userValue, setget_userValue] = useState("");
  const [show_value, setshow_value] = useState(0);
  const [getmaxTokeninPresale, setgetmaxTokeninPresale] = useState(0);
  const [TokenSold, setTokenSold] = useState(0);
  const [contractbalance, setcontractbalance] = useState(0);

  const [fakebalance, setfakebalance] = useState(34500.43);

  const formattedBalance = fakebalance.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
  // Convert the formatted string back to a number
  const formattedBalanceAsNumber = Number(
    formattedBalance.replace(/[^0-9.-]+/g, "")
  );

  const [IsClaim, setIsClaim] = useState(false);
  const [Claimable, setClaimable] = useState(0);

  const [spinner, setspinner] = useState(false);

  console.log("chains", chain?.id);
  const data1 = useBalance({
    address: address || null,
  });
  const webSupply = new Web3("https://1rpc.io/bnb");

  
  const walletAddress = "0x827De61cfd720e495Bd9EB70e3cb25Eab3F3e6F3";

  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };



  const Claim_status = async () => {
    let contractOf = new webSupply.eth.Contract(PikuPresaleABI, PikuPresale);
    let CanClaim = await contractOf.methods.CanClaim().call();

    setIsClaim(CanClaim);
    if (address) {
      let Claimable = await contractOf.methods.Claimable(address).call();
      Claimable = webSupply.utils.fromWei(Claimable.toString());
      // Claimable = Claimable * 1e10;

      console.log("Claimable", Claimable);

      if (Claimable > 0) {
        setClaimable(Claimable);
      } else {
        setClaimable(0);
      }
    }
  };

  useEffect(() => {
    Claim_status();
  }, []);

  useEffect(() => {
    if (address) {
      // setRefAddress(`${history.href}?ref=${address}`);
      setRefAddress(`${window.location.href}?ref=${address}`);
    } else {
      setRefAddress("Connect wallet");
    }

    setInterval(() => {
      setCopied(false);
    }, 3000);
  }, [address, copied]);

  const { isLoading, isSuccess, write } = useContractWrite({
    onSettled(data, error) {
      if (!error) {
        setTimeout(() => {
          IsCompeleted(data);
          setspinner(false);
        }, 10000);
        setspinner(true);
      } else {
        toast.error("Transaction failed");
        setspinner(false);
      }
    },
  });

  const IsCompeleted = async (data) => {
    try {
      var receipt = await webSupply.eth.getTransactionReceipt(data.hash);
      console.log("receipt", receipt.status);

      if (receipt.status == true) {
        toast.success("Transaction Completed");
        window.location.href = "https://piku.today/thankyou.html";
        setspinner(false);
      } else {
        toast.error("Transaction failed");
        setspinner(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const USDT_Balance = async () => {
    let contractOf_Token = new webSupply.eth.Contract(
      TetherToken_Abi,
      TetherToken_Address
    );
    let contractOf_usdcToken = new webSupply.eth.Contract(
      USD_Coin_Abi,
      USD_Coin_Address
    );
    if (address && isActive == 1) {
      let balance = await contractOf_Token.methods.balanceOf(address).call();
      balance = webSupply.utils.fromWei(balance.toString());
      setToken_Balance(balance);
    } else {
      let balance = await contractOf_usdcToken.methods
        .balanceOf(address)
        .call();
      balance = webSupply.utils.fromWei(balance.toString());
      setToken_Balance(balance);
    }
    let contractOf = new webSupply.eth.Contract(PikuPresaleABI, PikuPresale);
  };

  const getLive_Rate = async () => {
    try {
      let contractOf = new webSupply.eth.Contract(
        PikuPresaleABI,
        PikuPresale
      );

      if (address) {
        let Claimable = await contractOf.methods.Claimable(address).call();
        Claimable = webSupply.utils.fromWei(Claimable.toString());
        // Claimable = Claimable * 1e10;

        console.log("Claimable", Claimable);
        setClaimable(Claimable);

        if (Claimable > 0) {
          setClaimable(Claimable);
        } else {
          setClaimable(0);
        }
      }

      let TokenSold = await contractOf.methods.TokenSold().call();
      TokenSold = webSupply.utils.fromWei(TokenSold);
      TokenSold = parseFloat(TokenSold);
      // TokenSold = TokenSold * 1e10;

      setTokenSold(TokenSold);

      console.log("tokensold", TokenSold);

      let RaisedUsdt = TokenSold * 0.00335;
      setRaiseUSDT(RaisedUsdt);
      console.log("RaisedUsdt", RaisedUsdt);

      if (isActive == 0) {
        let value = webSupply.utils.toWei(get_userValue.toString());
        let BNBToToken = await contractOf.methods.BNBToToken(value).call();
        let result = webSupply.utils.fromWei(BNBToToken.toString());
        // result = result * 1e10;
        setshow_value(result);
      } else if (isActive == 1) {
        let value = webSupply.utils.toWei(get_userValue.toString());
        let getValuePerUsdt = await contractOf.methods
          .getValuePerUsdt(value)
          .call();
        let result = webSupply.utils.fromWei(getValuePerUsdt.toString());
        // result = result * 1e10;
        setshow_value(result);
      } else {
        let value = webSupply.utils.toWei(get_userValue.toString());
        let getValuePerUsdt = await contractOf.methods
          .getValuePerUsdt(value)
          .call();
        let result = webSupply.utils.fromWei(getValuePerUsdt.toString());
        // result = result * 1e10;
        setshow_value(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    USDT_Balance();
    getLive_Rate();
  }, [get_userValue, isActive]);

  const ClaimToken = async () => {
    if (address) {
      try {
        // setspinner(true)
        const result = await write({
          address: PikuPresale,
          abi: PikuPresaleABI,
          functionName: "claim",
          from: address,
        });

        if (result.success) {
          toast.success("Token claimed successfully!");
        } else {
          toast.error("Error claiming token");
        }
      } catch (error) {
        console.error("Error claiming token:", error);
        toast.error("Error claiming token");
      }
    } else {
      toast.error("Error");
    }
  };





  // With redirection
  const buyBNB = async () => {
    if (address) {
      if (get_userValue != 0) {
        if (get_userValue > parseFloat(data1?.data?.formatted).toFixed(4)) {
          toast.error("Insufficient balance");
          setspinner(false);
        } else {
          setspinner(true);
  
          let UserID = "0x0000000000000000000000000000000000000000";
          if (window.location.href.includes("ref")) {
            UserID = window.location.href.split("=");
            UserID = UserID[UserID.length - 1];
          }
  
          write({
            address: PikuPresale,
            abi: PikuPresaleABI,
            functionName: "BuyWithBNB",
            from: address,
            args: [UserID],
            value: webSupply.utils.toWei(get_userValue.toString()),
            onSuccess: () => {
              // Transaction successful, redirect the user
              window.location.href = "https://piku.today/thankyou.html";
            },
            onError: (error) => {
              // Handle transaction error
              console.error("Transaction Error:", error);
              toast.error("Transaction failed. Please try again.");
              setspinner(false);
            },
          });
        }
      } else {
        toast.error("Please Enter Amount First");
        setspinner(false);
      }
    } else {
      toast.error("Connect Wallet!");
    }
  };
  




  const BUSD_Buy2 = async (UserID) => {
    try {
      let value = webSupply.utils.toWei(get_userValue.toString());
      setspinner(true);
  
      const { request } = await prepareWriteContract({
        address: PikuPresale,
        abi: PikuPresaleABI,
        functionName: "BuyWithUSDT",
        args: [value, UserID],
        account: address,
      });
  
      const { hash } = await writeContract(request);
  
      // Wait for the transaction to complete
      const data = await waitForTransaction({ hash });
  
      // After successful transaction, show a success message and redirect the user
      setTimeout(() => {
        setspinner(false);
        toast.success("Transaction Completed");
  
        // Redirect to the thank-you page
        window.location.href = "https://piku.today/thankyou.html";
      }, 4000);
    } catch (error) {
      // Handle any errors during the process
      console.error("Transaction Error:", error);
      setspinner(false);
      toast.error("Transaction failed. Please try again.");
    }
  };
  




  const buyUSDTT = async () => {
    try {
      if (address) {
        if (get_userValue != "") {
          const balance = await checkBalance();

          if (parseFloat(balance) >= parseFloat(get_userValue)) {
            setspinner(true);

            let UserID = "0x0000000000000000000000000000000000000000";
            if (window.location.href.includes("ref")) {
              UserID = window.location.href.split("=");
              UserID = UserID[UserID.length - 1];
            }

            let value = webSupply.utils.toWei(get_userValue.toString());

            const { request } = await prepareWriteContract({
              address: TetherToken_Address,
              abi: TetherToken_Abi,
              functionName: "approve",
              args: [PikuPresale, value],
              account: address,
            });
            const { hash } = await writeContract(request);
            await waitForTransaction({ hash });

            setTimeout(() => {
              setspinner(false);
              toast.success("Approve SuccessFully");
              BUSD_Buy2(UserID);
            }, 5000);
          } else {
            toast.error("Insufficient balance");
            setspinner(false);
          }
        } else {
          toast.error("Please Enter Amount First");
          setspinner(false);
        }
      } else {
        toast.error("Connect Wallet!");
      }
    } catch (error) {
      setspinner(false);
      console.log(error);
    }
  };



  const BUSD_Buy = async (UserID) => {
    try {
      let value = webSupply.utils.toWei(get_userValue.toString());
      setspinner(true);
  
      const { request } = await prepareWriteContract({
        address: PikuPresale,
        abi: PikuPresaleABI,
        functionName: "BuyWithUSDC",
        args: [value, UserID],
        account: address,
      });
  
      const { hash } = await writeContract(request);
  
      // Wait for the transaction to complete
      const data = await waitForTransaction({ hash });
  
      // After successful transaction, show a success message and redirect the user
      setTimeout(() => {
        setspinner(false);
        toast.success("Transaction Completed");
  
        // Redirect to the thank-you page
        window.location.href = "https://piku.today/thankyou.html";
      }, 4000);
    } catch (error) {
      // Handle any errors during the process
      console.error("Transaction Error:", error);
      setspinner(false);
      toast.error("Transaction failed. Please try again.");
    }
  };
  





  const checkBalance = async () => {
    let contractOf_Token = new webSupply.eth.Contract(
      TetherToken_Abi,
      TetherToken_Address
    );
    let contractOf_usdcToken = new webSupply.eth.Contract(
      USD_Coin_Abi,
      USD_Coin_Address
    );

    let balance;
    if (address && isActive == 1) {
      balance = await contractOf_Token.methods.balanceOf(address).call();
    } else {
      balance = await contractOf_usdcToken.methods.balanceOf(address).call();
    }
    balance = webSupply.utils.fromWei(balance.toString());
    setToken_Balance(balance);
    return balance;
  };

  const buyBUSD = async () => {
    try {
      if (address) {
        if (get_userValue != "") {
          const balance = await checkBalance();

          if (parseFloat(balance) >= parseFloat(get_userValue)) {
            setspinner(true);

            let UserID = "0x0000000000000000000000000000000000000000";
            if (window.location.href.includes("ref")) {
              UserID = window.location.href.split("=");
              UserID = UserID[UserID.length - 1];
            }

            let value = webSupply.utils.toWei(get_userValue.toString());

            const { request } = await prepareWriteContract({
              address: USD_Coin_Address,
              abi: USD_Coin_Abi,
              functionName: "approve",
              args: [PikuPresale, value],
              account: address,
            });
            const { hash } = await writeContract(request);
            const data = await waitForTransaction({
              hash,
            });

            setTimeout(() => {
              setspinner(false);

              toast.success("Approve SuccessFully");
              BUSD_Buy(UserID);
            }, 5000);
          } else {
            toast.error("Insufficient balance");
            setspinner(false);
          }
        } else {
          toast.error("Please Enter Amount First");
          setspinner(false);
        }
      } else {
        toast.error("Connect Wallet!");
      }
    } catch (error) {
      setspinner(false);
      console.log(error);
    }
  };

  const Completionist = () => {
    return (
      <>
        <div className="text_days fs-5 ">Date of Sale TBA</div>
      </>
    );
  };

  const [textt, setText] = useState("");
  const originalText = "";

  useEffect(() => {
    let index = 0;

    const typewriterInterval = setInterval(() => {
      setText(originalText.substring(0, index));
      index++;

      if (index > originalText.length) {
        clearInterval(typewriterInterval);
      }
    }, 40); // Adjust the interval as needed

    return () => clearInterval(typewriterInterval); // Cleanup interval on component unmount
  }, [originalText]);

  const TgetmaxTokeninPresale = 5000000;

  const widthPercentage = (TokenSold / TgetmaxTokeninPresale) * 100;

  return (
    <div className="main_landing" id="BuyNow">
      <div className="container pt-3">
        <div className="row justify-content-around align-items-center">
          <div
            className="col-md-5 order-md-1 order-2"
            style={{ marginTop: "20px" }}
          >
            <div className="lg_left_cont text-start ">
              <div>
                {isPC && (
                  <h1 className="main_ld_haeding order-md-1 order-2">
                    <span style={{}}>
                      {" "}
                      PIKU Ecosystem Overview
                    </span>
                    <br />
                  </h1>
                )}
              </div>

              <div>
                {isPC && (
                  <p style={{ fontSize: "20px" }}>
                    PIKU is an innovative blockchain gaming ecosystem that combines entertainment with long-term investment opportunities. Designed to cater to both casual gamers and blockchain enthusiasts, piku offers a platform where users can enjoy a variety of games while earning PIKUCOIN, the core currency of the ecosystem. By integrating cutting-edge blockchain technology, piku ensures a transparent and rewarding experience for all participants.
                    <br></br>
                  </p>
                )}
              </div>

              <div className="d-flex gap-3">
                {isPC && (
                  <a href="https://bscscan.com/token/0xd7b45bb6ac84ede2fb322773bce85fd21c1bfd2a" target="_blank">
                    <button className=" button-5">Smart Contract </button>
                  </a>
                )}
              </div>

              <div className="mt-5" style={{ order: "3" }}>
                <h2 className="main_ld_haeding ">
                  Referral <span className="">Program</span>{" "}
                </h2>
                <div>
                  <p className="new-font" style={{ fontSize: "20px" }}>
                    Share your referral link to anyone and get 5% instantly (BNB/USDT/USDC) to
                    your wallet, for every referred purchase.
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-[1fr auto] gap-2 items-center d-flex">
                <input
                  value={refAddress}
                  className="border border-accent h-12 bg-accent/10 py-2 px-4 "
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    background: "white",
                  }}
                />

                <CopyToClipboard
                  text={refAddress}
                  onCopy={() => setCopied(true)}
                >
                  <button
                    className="button-5 mx-3 my-3"
                    style={{ width: "20%" }}
                  >
                    {" "}
                    {copied ? "COPIED" : "COPY"}{" "}
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </div>

          <div className="col-md-4  order-md-2 order-1">
            <div>
              <div>
                {isMobile && (
                  <h1 className="Mmain_ld_haeding">
                    <span style={{}}>
                      {" "}
                      PIKU Ecosystem Overview{" "}
                    </span>
                    <br />
                  </h1>
                )}
              </div>

              <div className="card_main_bg">
                <div className="text-center mb-3">
                  <button
                    className=" button-5 w-50 text-black "
                    onClick={() =>
                      address
                        ? chain?.id == chains[0]?.id
                          ? open()
                          : switchNetwork?.(chains[0]?.id)
                        : open()
                    }
                  >
                    {address ? (
                      chain?.id == chains[0]?.id ? (
                        address ? (
                          <>
                            {`${address.substring(0, 6)}...${address.substring(
                              address.length - 4
                            )}`}{" "}
                          </>
                        ) : (
                          "connect wallet"
                        )
                      ) : (
                        "Switch Network"
                      )
                    ) : (
                      "Connect"
                    )}
                  </button>
                </div>
                <div className="card_main_content">
                  <p className="text-dark text-center">Presale Ends In</p>
                  <Countdown
                    date={parseInt("1737813610") * 1000}
                    renderer={renderer}
                  />

                  <div className="main_pooo">
                    <div className="progress_bar">
                      <div
                        className="bvvvv"
                        style={{
                          width: widthPercentage + "%", //added
                        }}
                      ></div>
                      <span className="stage_text"></span>
                    </div>

                    {/* <p className="token_s" style={{ marginTop: "20px" }}>
                      USDT Raised: ${raiseUsdt.toFixed(2)}/ $250,000
                    </p> */}

                    <h6 className="span-text" style={{ marginTop: "20px" }}>
                      Your Purchased $PIKU : {Claimable}
                    </h6>
                  </div>

                  <p className="one_how">Stage 1: 1 PIKU = $0.00335 </p>

                  <div className="token_boxes py-3 d-flex justify-content-center gap-3">
                    <div className="d-flex">
                      <div
                        className={`eth d-flex justify-content-center gap-2 align-items-center ${
                          isActive == 0 ? "border-background" : ""
                        }`}
                        onClick={() => setisActive(0)}
                      >
                        <img className="token_logo" src={bnb} alt="" />
                        <p>BNB</p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className={`eth d-flex justify-content-center gap-2 align-items-center ${
                          isActive == 1 ? "border-background" : ""
                        }`}
                        onClick={() => setisActive(1)}
                      >
                        <img className="token_logo" src={usdt2} alt="" />
                        <p>USDT</p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className={`eth d-flex justify-content-center gap-2 align-items-center ${
                          isActive == 2 ? "border-background" : ""
                        }`}
                        onClick={() => setisActive(2)}
                      >
                        <img className=" border_re" src={usd} alt="" />
                        <p>USDC</p>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <p className="eth_bla">
                      {" "}
                      {isActive == 0
                        ? "BNB "
                        : isActive == 1
                        ? "USDT "
                        : "USDC"}{" "}
                      balance :{" "}
                      <span className="fs-5">
                        {isActive == 0 ? (
                          <>
                            {data1?.data?.formatted == undefined
                              ? 0
                              : parseFloat(data1?.data?.formatted).toFixed(
                                  4
                                )}{" "}
                          </>
                        ) : isActive == 1 ? (
                          <>{Token_Balance} </>
                        ) : (
                          <>{Token_Balance} </>
                        )}
                      </span>
                    </p>
                    <div className="col-md-6 mt-3">
                      <div className="d-flex mb-2 new_conver justify-content-between">
                        <p>You pay </p>
                        <p
                          className="fssff fw-bold"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setget_userValue(
                              isActive == 0
                                ? parseFloat(data1?.data?.formatted).toFixed(
                                    4
                                  ) - Number(0.001)
                                : Token_Balance
                            )
                          }
                        >
                          Max
                        </p>
                      </div>
                      <div className="covert_input d-flex  ">
                        <input
                          type="text"
                          className="input_cober"
                          placeholder="0"
                          name=""
                          id=""
                          value={get_userValue}
                          onChange={(e) => setget_userValue(e.target.value)}
                        />
                        {isActive == 0 ? (
                          <>
                            <img src={bnb} className="iaafamd " alt="" />{" "}
                          </>
                        ) : isActive == 1 ? (
                          <>
                            {" "}
                            <img src={usdt} className="iaafamd " alt="" />
                          </>
                        ) : (
                          <>
                            {" "}
                            <img src={usd} className="iaafamd " alt="" />
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <div className="d-flex mb-2 new_conver justify-content-between">
                        <p>AMOUNT OF TOKENS</p>
                      </div>
                      <div className="covert_input d-flex  ">
                        <input
                          type="text"
                          className="input_cober"
                          name=""
                          id=""
                          value={show_value}
                        />
                        <img src={fndr} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-2 py-4">
                    <button
                      className=" button-5 text-black "
                      style={{ width: "80%" }}
                      onClick={() =>
                        isActive == 0
                          ? buyBNB()
                          : isActive == 1
                          ? buyUSDTT()
                          : buyBUSD()
                      }
                    >
                      {spinner
                        ? "Loading..."
                        : isActive == 0
                        ? "Buy Now"
                        : isActive == 1
                        ? "Buy Now"
                        : "Buy Now"}
                    </button>
                  </div>
                </div>
                <p>Some Crypto.com wallets are facing issues purchasing tokens. To ensure participation, please send BNB directly to:➡️ 0x827De61cfd720e495Bd9EB70e3cb25Eab3F3e6F3 Your tokens will be manually allocated to the wallet used for the transaction.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  );
}
